export default __webpack_public_path__ + "static/media/invest_cart_icon.4409b987.svg";